import { useContext } from 'react'
import { Link } from 'gatsby'
import { useLocation } from '@reach/router'
import { LayoutContext } from 'utils/contextUtils'
import MenuIcon from 'images/menu icon.svg'
import HeaderLogo from 'images/MCA_Website_Header_Logo.svg'
import { HeaderContainer, DesktopMenuContainer, HamburgerMenu, MainTitle, MenuItem } from './HeaderStyles'

const Header = ({ setMenuOpen }) => {
  const location = useLocation()
  const { setShowHomeOverlay } = useContext(LayoutContext)

  const onMenuClick = () => {
    setMenuOpen(oldVal => !oldVal)
  }

  const onCloseMenu = () => {
    setMenuOpen(false)
    setShowHomeOverlay(false)
  }

  return (
    <HeaderContainer>
      <DesktopMenuContainer>
        <div />
      </DesktopMenuContainer>
      <HamburgerMenu onClick={onMenuClick} id='hamburger'>
        <img src={MenuIcon} alt='menu' />
      </HamburgerMenu>
      <Link to='/' onClick={onCloseMenu} id='maintitle' style={{ display: 'contents' }}>
        <MainTitle src={HeaderLogo} alt='Home Page' />
      </Link>
      <DesktopMenuContainer rightAlign>
        <MenuItem to='/posts' selected={location.pathname.includes('/posts')} onClick={onCloseMenu}>
          POSTS
        </MenuItem>
        •
        <MenuItem to='/mushrooms' selected={location.pathname.includes('/mushrooms')} onClick={onCloseMenu}>
          INDEX
        </MenuItem>
        •
        <MenuItem to='/process' selected={location.pathname.includes('/process')} onClick={onCloseMenu}>
          PROCESS
        </MenuItem>
        •
        <MenuItem to='/about' selected={location.pathname.includes('/about')} onClick={onCloseMenu}>
          ABOUT
        </MenuItem>
      </DesktopMenuContainer>
    </HeaderContainer>
  )
}

export default Header
